import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private http: HttpClient) { }


  getSEO(url: string) {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/contenidoauto/api/Seo/byURL?url=${url}`);
  }


} 